
namespace RioERP.Products {
    export class ProductSpecificationsBooksColumns {
        static columnsKey = 'Products.ProductSpecificationsBooks';
    }
}